import React, { useEffect } from 'react'
import CSSModules from 'react-css-modules'
import { useFlash } from 'spa/hooks/useFlash'
import FlashType from 'javascripts/layouts/v2/FlashType'
import ClientHeader from 'spa/client/components/ClientHeader'
import ClientFooter from 'spa/client/components/ClientFooter'
import ClientMenu from 'spa/client/components/ClientMenu'
import { Flash, FlashCloseHandler } from 'javascripts/layouts/v2/Flash'
import styles from './style.module.scss'
import { ClientGlobalStyles } from 'spa/client/styles/GlobalStyles'

interface ClientLayoutProps {
  flash?: FlashType;
}

const ClientLayout: React.FC<ClientLayoutProps> = CSSModules<React.FC<ClientLayoutProps>>((props) => {
  const [flash, setFlash] = useFlash(props.flash)
  const handleClose: FlashCloseHandler = (property) => {
    setFlash({ ...flash, [property]: undefined })
  }

  useEffect(() => setFlash({ ...flash, ...props.flash }), [props.flash])

  return (
    <>
      <ClientGlobalStyles />
      <ClientHeader />
      <ClientMenu />
      <main styleName='main'>
        <div styleName='flash-container'>
          <Flash flash={flash ?? {}} onClose={handleClose} additionalClass={'client-flash'} />
        </div>
        {props.children}
      </main>
      <ClientFooter />
    </>
  )
}, styles)

export default ClientLayout
